import React, { useRef,useEffect,useState, useContext } from 'react'
import logo from "./assets/lhrclogoSVG_W.svg"
import brandline from "./assets/BrandLinewhite.png"
import { useNavigate } from 'react-router-dom';
import DataContext from './context/DataContext';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { createPost } from './api/axiosPosts';
import { Password } from 'primereact/password';
import ReactCountryFlag from "react-country-flag"
import { LoginUser } from './api/axiosLogin';
import { AllToasts } from './components/Toasts/AllToasts';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useTranslation } from 'react-i18next';
import LanguageButton from './LanguageButton';
import { getNotifications } from './api/axiosNotifications';



const Login = () => {

  const { t } = useTranslation();
  const { i18n } = useTranslation();

  const {
    fetcherror, setFetcherror,
    language, setLanguage,
    isUserAuntheticated, setIsUserAuntheticated,
    auntheticatedUser, setAuntheticatedUser,
    accessToken, setAccessToken,
    refreshToken, setRefreshToken,
    notifications, setNotifications,
    isLoadingNotifications, setIsLoadingNotifications,
    fetcherrorNotifications, setFetcherrorNotifications,
  } = useContext(DataContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailInvalid, setEmailInvalid] = useState("");
  const [passwordInvalid, setPasswordInvalid] = useState("");
  const [resetPage, setResetPage] = useState(false);
  const [invalidCredentials, setInvalidCredentials] = useState("none");
  const [loader, setLoader] = useState(false);

  const toast = useRef(null);
  const navigate = useNavigate();

  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  useEffect(() => {
    setEmail("");
    setPassword("");
    
    setLanguage("GB"); 
    i18n.changeLanguage("en"); 
  }, []);



  const checkInvalidInput = () => { 

    if (!email) setEmailInvalid("p-invalid");
    if (!password) setPasswordInvalid("p-invalid");
  }

  const emailClass = `w-full mb-3 pr-5 loginformField ${emailInvalid}`
  const passwordClass = `'w-full mb-0 loginformField' ${passwordInvalid}`
  
  const signInLabel = () => { 

    return (<>
      {!loader && <span className='pl-5 pr-5'>{t('Sign In')}</span>}
      {loader &&
        <span className='flex justify-content-center'>
          <span >{t('Signing In')}</span>
          <span className='text-center flex items-center justify-center pl-2 pr-2'> 
        </span>
          {<ProgressSpinner style={{ width: '15px', height: '15px' }} strokeWidth="8" fill="#41A6D7" animationDuration=".5s" />}
        </span>}
    </>)
  }

const mobileText = (t) => { 
  return (
    <div className='text-sm md:text-base'>
      {t(t)}
    </div>
  )
}

  
 const LoadNotificationsCallBack = (err,success) => {
  
 if (success){
  getNotifications(setNotifications, setIsLoadingNotifications, setFetcherrorNotifications,null);
 }
 }

  return (
    
    <div className='login'>
       <Toast ref={toast} />
      
      <div className='grayDiv'>
        <span style={{marginLeft: "85%", float:"right" }}>
          <LanguageButton />
        </span>
      </div>
      
      <div className='darkBDiv'></div>

      <div className='whiteDiv'>

        <div className='loginLogo'>
          <img src={logo} className='llogin' />
          <img src={brandline } alt="BrandLine"  className='brandLine'/>
        </div>

        <div className='loginForm'>
          <div className='m-3 mb-2 text-xl md:text-3xl font-bold text-primary text-center'>HAKIKIGANJANI</div>
            
          
          {/* Login Page */}
          {!resetPage &&  
                <><form action=""
            onSubmit={(e) => {
              e.preventDefault();
              checkInvalidInput();
              LoginUser(
                email, setEmail,
                password, setPassword,
                setIsUserAuntheticated,
                setAuntheticatedUser,
                setFetcherror,
                handleAllToasts,
                setLoader,
                t,
                LoadNotificationsCallBack
              )
            }}>
                
                

                      <label htmlFor="email" className="block text-sm md:text-base text-900 font-medium mb-2">{t('Email')}</label>
                        <InputText
                          keyfilter="email"
                          className={emailClass}
                          type="text"
                          placeholder={t('Enter Your Email')}
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          onFocus={() => setEmailInvalid("")}
                        />
                        

                      <label htmlFor="password" className="block text-sm md:text-base text-900 font-medium mb-2">{t('Password')}</label>
                        <Password
                        className={passwordClass}
                        toggleMask
                        feedback={false}
                        placeholder={t('Enter Password')}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onFocus={() => setPasswordInvalid("")}
                        />
                      <span style={{ color: "red", fontSize: "14px", display: `${invalidCredentials}`}}>{t('Either Email  or Password is invalid')}</span>
                      <p className='mb-5'></p>
                      <div className='flex flex-row justify-content-end'>
                        
                          <Button
                          className='mb-0  font-light text-sm  loginformField p-1 pl-2 pr-2 md:p-2 md:pl-3 md:pr-3'
                          label={signInLabel() }
                          role='submit'
                          
                          />
                        
                        </div> 
                </form>
                <p className='resetPasswd'>{t('Forgot Your Password?')}
                  <button
                   role='none'
                  onClick={()=>setResetPage(true)}
                    className='btnresetPasswd'>{t('Reset')}
                  </button>
                </p>
            </>} 
          


          {/* Reset Password Page */}
          {resetPage &&
            <>
             <form action=""
                    onSubmit={(e) => {  e.preventDefault(); checkInvalidInput() }}>
                
                

                      <label htmlFor="email" className="mt-6 block text-900 font-medium mb-2">
                        <span style={{ textAlign: "justify" }}>
                        {t('Enter Your Email to reset Password, You will receive an Email with the Link for the new Password')}
                        </span> </label>
                        <InputText
                          keyfilter="email"
                          className={emailClass}
                          type="text"
                          placeholder={t('Enter Your Email')}
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          onFocus={() => setEmailInvalid("")}
                        />

                           
                      <div className='flex flex-row justify-content-end'>
                        
                        <Button
                        className='mb-3  font-light text-sm  loginformField p-2 pl-5 pr-5'
                        label={t('Reset')}
                        role='submit'
                        icon="pi pi-check"
                        />
                      
                      </div> 
            </form>
            <p className='resetPasswd'> {t('Go back to Login Page?')}
              <button
                role='none'
                onClick={() => setResetPage(false)}
                className='btnresetPasswd'>{t('Login Page')}
              </button>
            </p>
            </>}


            
       </div>

      </div>
      
      
    </div>
  )
}

export default Login